var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeftSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: var(--dark-grey-color);\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-left",
    transform: "translate(-253 -244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    width: 21,
    height: 21,
    transform: "translate(253 244)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "angle-left-2",
    "data-name": "angle-left",
    transform: "translate(363.979 261) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-2",
    d: "M103.732,6.594l-5.16,5.16a.84.84,0,1,1-1.189-1.188L101.95,6,97.385,1.434A.84.84,0,0,1,98.573.246l5.16,5.16a.84.84,0,0,1,0,1.188Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeftSm);
export default __webpack_public_path__ + "static/media/angle-left-sm.658033af14cebbe2d43a80f11c7358ee.svg";
export { ForwardRef as ReactComponent };